import { GettingStartedService } from "./getting-started.service";
import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";

import * as _ from "underscore";
import { JobsService } from "../jobs-and-tasks/jobs.service";
import { DomSanitizer } from "@angular/platform-browser";
import { NgIf } from "@angular/common";
import { EditorModule } from "primeng/editor";

// declare var jQuery: any;

@Component({
    selector: "app-getting-started",
    templateUrl: "./getting-started.component.html",
    styleUrls: ["./getting-started.component.scss"],
    imports: [NgIf, EditorModule]
})
export class GettingStartedComponent implements OnInit {
  user: any = {};
  validUsers = [
    "fabiancabau@gmail.com",
    "khosla.samir+p14@gmail.com",
    "christiangusukuma@gmail.com",
    "testclienthub@gmail.com",
  ];
  page: any;
  content: any = "";

  constructor(
    private localStorage: LocalStorageService,
    private gettingStartedService: GettingStartedService,
    public jobsService: JobsService,
    public _sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.user = this.localStorage.get("user");
    this.localStorage.set("fromSignIn", false);
    if (this.validUsers.includes(this.user.email)) {
    }

    this.gettingStartedService.getWelcomePageFree().then((res) => {
      this.content = res.content;
    });
  }

  async save() {
    this.gettingStartedService.saveWelcomePageFree(this.content).then((res) => {
      console.log(res);
    });
  }
}
